// Analytics adapter client, could not be imported directly from repository cause of transpilation issue
// to be solved in the future: https://jira.willhillatlas.com/browse/SBARCH-152
import { publish, unsubscribe, subscribe } from '@wh/message-bus';

/**
 * Wait for analytics adapter to be ready
 *
 * @param {function} callback
 * @return void
 */
const whenReady = (callback) => {
    const token = subscribe('wh.analytics.adapter.ready', () => {
        unsubscribe(token);
        callback();
    });
};

/**
 * Send eventPartial for adapter to consume
 *
 * @param {object} payload
 * @return void
 */
export const track = (payload) =>
    whenReady(() => {
        publish('wh.common.command.dli.tl.eventPartial', payload);
    });
